import React, { Component, Fragment } from "react";

import styles from "./Footer.module.scss";

export default class Footer extends Component {
  render() {
    return (
      <section>
        <footer id={styles.Footer}>
          <p className={styles.textStyle}>
            Copyright © 2021 Agrinol, Inc. All rights reserved. Patent Pending.
          </p>
          <p className={styles.textStyle} id={styles.Trademark}>
            AgriCarbon, AgriCarbo2n, AgriFresh, AgriClean, AgriFlower, and
            AgriCool are all trademarks of Agrinol Inc.
          </p>
        </footer>
      </section>
    );
  }
}
